import React, { useState } from 'react'
import { Container, Grid } from "@material-ui/core"
import styles from './footer.module.css'
import InfoRender from './info_render'
import strings from '../../strings/strings.json'
import { useRouter } from 'next/router'
import { emailValidation } from '../../modules/email_validation/email_validation'
import Api from '../../../pages/api/api'
import CustomInput from '../../modules/custom_input/custom_input'

export default function Footer(props) {
    const router = useRouter()
    const [emailText, setEmailText] = useState('')



    const mailConfirmHandler = () => {
        if (!emailText || !emailValidation(emailText))
            props.setSnack(true, "error", strings.general_validEmail)
        else
            Api.UserEmail({
                "user_email": emailText
            })
                .then(result => {
                    props.setSnack(true, "success", strings.general_successOperation)
                })
                .catch(err => {
                    props.setSnack(true, "error", strings.general_faildOperation)
                })
    }
    return (

        <div className={styles.footer_container}>
            <Container>
                <div className={styles.footerLogo_container}>
                    <img className={styles.footerLogo} alt="footerLogo" src='/assets/icons/main_logo.svg' />
                </div>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={4}>
                        <InfoRender img="mark" text={strings.footer_address} />
                        <InfoRender img="phone" text={strings.footer_phone} />
                    {/*     <InfoRender img="fax" text={strings.footer_fax} /> */}
                        <InfoRender img="mail" text={strings.footer_mail} />
                    </Grid>
                    <Grid item xs={6} sm={5} md={2}>
                        <div className={styles.footerColumn_parent}>
                            <span className={styles.footerColumn_child_c1} onClick={() => router.push('/')}>{strings.footer_mainHome}</span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://docs.cyberno.ir/fa/blog/rules">{strings.footer_rules}</a></span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_API_SERVER_ADDRESS + '/apidocs'}>{strings.footer_apiDoc}</a></span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://cyberno.ir/page/about">{strings.footer_aboutUs}</a></span>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <div className={styles.footerColumn_parent}>
                            <span className={styles.footerColumn_child_c1} onClick={() => router.push('/search')}><a className={styles.footerColumn_child_a}>{strings.general_search}</a></span>
                            <span onClick={() => router.push('/aboutApp')} className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a}>{strings.footer_aboutSystem}</a></span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://docs.cyberno.ir/fa/blog/mobsl-intro">{strings.footer_help}</a></span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://docs.cyberno.ir/fa/blog/faq">{strings.general_faq}</a></span>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <div className={styles.symbol_container}>
                            <CustomInput
                                setInputValue={emailText}
                                isEmail={true}
                                placeHolder={strings.general_email}
                                endAdornment={
                                    <button className={styles.btnConfirm_mail_btn} onClick={() => mailConfirmHandler()} >
                                        {strings.general_confirm}
                                    </button>
                                }
                                startAdornment={<img src='/assets/icons/mail-fill.svg' alt='Icon' />}
                                enterPressed={ev => ev.key === "Enter" && mailConfirmHandler()}
                                value={val => setEmailText(val.target.value)}
                            />
                        </div>
                        <div className={`${styles.symbol} flex justify-around`}>
                            <div>
                                <a referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=220542&amp;Code=yDhWa3PZVphg3Ki0XkHS">
                                    <img
                                        id="yDhWa3PZVphg3Ki0XkHS"
                                        referrerPolicy="origin"
                                        className={`${styles.govahiname_container} enamad`}
                                        src="https://Trustseal.eNamad.ir/logo.aspx?id=220542&amp;Code=yDhWa3PZVphg3Ki0XkHS"
                                        alt="Enamad"
                                    />
                                </a>
                            </div>
                            <div>
                                <img className={`${styles.govahiname_container} ${styles.enamad}`} alt="senf" src="../../assets/icons/senf.png" />
                            </div>
                            <div>
                                <img className={`${styles.govahiname_container} ${styles.enamad}`} alt="daneshbonyan" src="/assets/icons/daneshbonyan.png" />
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <div className={styles.divider} />
                <Grid container spacing={1}>
                    <Grid item sm={12} md={6}>
                        <span className={styles.footerNote}>{strings.footer_footNote}</span>
                    </Grid>
                    <Grid style={{ width: "100%" }} item sm={12} md={6}>
                        <div className={styles.footerNoteIcons_parent}>
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://t.me/cyberno_ir")} alt="footer" src="/assets/icons/tlg.svg" />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://twitter.com/cyberno_ir")} alt="footer" src="/assets/icons/twitter.svg" />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://instagram.com/cyberno_ir")} alt="footer" src="/assets/icons/instagram.svg" />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://www.linkedin.com/company/cyberno")} alt="footer" src="/assets/icons/linkedin.svg" />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://github.com/cyberno-ir")} alt="footer" src="/assets/icons/github.svg" />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://ble.ir/cyberno")} alt="footer" src="/assets/icons/bale.svg" />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}
